import { formatDate } from "../../../dateUtils/formatDate.util";

const formatUpdateGasFlowRequestBody = (
  checkBoxRadioValue: string,
  appliedDay: Date | undefined,
  rate: string,
  newGasFlow: string,
  notes: string,
): string => {
  // const changedGasFlow = Object.entries(newGasFlow).map(
  //   ([key, value]) =>
  //     ` ${value}KWh/día/mes`
  // );
  const appliedDayFormatted =
    checkBoxRadioValue === "asap"
      ? "Cuanto antes"
      : formatDate(appliedDay as Date);

  return `Nuevo caudal diario de gas solicitado: ${newGasFlow}; Tarifa: ${rate};Fecha de aplicación: ${appliedDayFormatted}; ${
    notes.length ? `Notas: ${notes};` : ""
  }`;
};

export { formatUpdateGasFlowRequestBody };
